import type { AxiosInstance } from 'axios';
import type { Country } from './country.types';

export const countryQuery = async (
	axiosCmsInstance: AxiosInstance,
	cmsPath: string
): Promise<Country[]> => {
	const { data } = await axiosCmsInstance.get(cmsPath + '/countries.json');
	return data.data;
};
